var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _g, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 834,
    height: 622,
    viewBox: "0 0 834 622",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M833.562 546.272H0.673828V546.689H833.562V546.272Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M750.107 573.075H694.937V573.491H750.107V573.075Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M552.412 577.606H537.937V578.022H552.412V577.606Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M693.27 557.616H661.304V558.033H693.27V557.616Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.005 560.415H88.0605V560.831H160.005V560.415Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.392 560.415H174.848V560.831H185.392V560.415Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M375.724 567.445H219.674V567.861H375.724V567.445Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M395.463 471.979H73.8182C71.2984 471.974 68.8834 470.97 67.1032 469.187C65.3231 467.404 64.3232 464.987 64.3232 462.467V10.3259C64.3452 7.82059 65.3547 5.42513 67.1325 3.6598C68.9103 1.89448 71.3128 0.901875 73.8182 0.897583H395.463C397.985 0.897583 400.405 1.89969 402.188 3.68346C403.972 5.46723 404.974 7.88653 404.974 10.4092V462.467C404.974 464.99 403.972 467.409 402.188 469.193C400.405 470.977 397.985 471.979 395.463 471.979ZM73.8182 1.23074C71.4089 1.23515 69.0998 2.19533 67.3977 3.90052C65.6956 5.60571 64.7397 7.91658 64.7397 10.3259V462.467C64.7397 464.877 65.6956 467.187 67.3977 468.893C69.0998 470.598 71.4089 471.558 73.8182 471.562H395.463C397.874 471.558 400.184 470.598 401.889 468.894C403.594 467.189 404.553 464.878 404.558 462.467V10.3259C404.553 7.91504 403.594 5.60422 401.889 3.8995C400.184 2.19479 397.874 1.23514 395.463 1.23074H73.8182Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M755.787 471.979H434.126C431.605 471.974 429.188 470.971 427.405 469.188C425.622 467.405 424.619 464.989 424.614 462.467V10.3259C424.641 7.81907 425.654 5.42362 427.434 3.65876C429.215 1.8939 431.619 0.901828 434.126 0.897583H755.787C758.29 0.906253 760.688 1.90079 762.462 3.66565C764.236 5.4305 765.243 7.82346 765.265 10.3259V462.467C765.265 464.984 764.268 467.398 762.491 469.181C760.715 470.964 758.304 471.97 755.787 471.979ZM434.126 1.23074C431.715 1.23514 429.404 2.19479 427.699 3.8995C425.995 5.60422 425.035 7.91504 425.031 10.3259V462.467C425.035 464.878 425.995 467.189 427.699 468.894C429.404 470.598 431.715 471.558 434.126 471.562H755.787C758.198 471.558 760.509 470.598 762.213 468.894C763.918 467.189 764.878 464.878 764.882 462.467V10.3259C764.878 7.91504 763.918 5.60422 762.213 3.8995C760.509 2.19479 758.198 1.23514 755.787 1.23074H434.126Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M527.958 379.778H728.101C728.1 383.314 726.735 386.713 724.289 389.267C721.844 391.821 718.507 393.333 714.975 393.488C693.469 394.47 660.37 397.869 649.893 409.762C630.32 431.95 632.219 509.875 655.656 527.916C662.986 533.579 684.408 544.807 684.408 544.807H571.651C571.651 544.807 591.641 533.346 598.62 527.916C621.941 509.725 622.591 431.85 602.935 409.762C592.857 398.435 561.84 394.77 541.034 393.621C537.497 393.425 534.17 391.88 531.738 389.305C529.305 386.73 527.953 383.321 527.958 379.778Z",
    fill: "#37474F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M703.298 394.22C682.976 395.886 658.622 399.867 649.894 409.762C647.044 413.18 644.791 417.055 643.231 421.223H609.665C608.084 417.065 605.833 413.194 603.002 409.762C594.24 399.917 569.687 395.87 549.697 394.22H703.298Z",
    fill: "#1C262A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M613.213 379.878L615.945 348.778H576.483L573.768 379.878H613.213Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M613.213 379.878L615.945 348.778H618.06L615.345 379.878H613.213Z",
    fill: "#1C262B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M609.464 376.713L611.63 351.943H580.23L578.064 376.713H609.464Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M607.067 374.664L608.866 353.992H582.647L580.831 374.664H607.067Z",
    fill: "#FAFAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M626.006 379.778H665.635L661.237 329.522H621.608L626.006 379.778Z",
    fill: "#1C262A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M626.007 379.778H624.124L619.727 329.522H621.609L626.007 379.778Z",
    fill: "#1C262B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M629.604 374.664H661.153L657.655 334.652H626.105L629.604 374.664Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M631.902 371.366H658.272L655.34 337.951H628.987L631.902 371.366Z",
    fill: "#FAFAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M645.23 352.976C644.804 353.404 644.298 353.744 643.74 353.976C643.183 354.207 642.585 354.327 641.981 354.327C641.378 354.327 640.78 354.207 640.222 353.976C639.665 353.744 639.159 353.404 638.733 352.976C637.878 352.115 637.397 350.95 637.397 349.736C637.397 348.522 637.878 347.357 638.733 346.496C639.597 345.639 640.765 345.159 641.981 345.159C643.198 345.159 644.365 345.639 645.23 346.496C646.085 347.357 646.565 348.522 646.565 349.736C646.565 350.95 646.085 352.115 645.23 352.976Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M643.28 358.606C643.59 358.291 643.96 358.041 644.367 357.871C644.775 357.7 645.212 357.612 645.654 357.612C646.096 357.612 646.533 357.7 646.941 357.871C647.348 358.041 647.718 358.291 648.028 358.606C648.509 359.07 648.84 359.668 648.977 360.323C649.114 360.978 649.051 361.658 648.795 362.277C648.54 362.895 648.105 363.422 647.546 363.789C646.987 364.157 646.331 364.347 645.662 364.336C644.992 364.351 644.333 364.163 643.772 363.796C643.21 363.43 642.772 362.903 642.515 362.284C642.258 361.666 642.193 360.983 642.33 360.327C642.466 359.671 642.797 359.071 643.28 358.606Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.8 322.492H323.684V115.803L136.8 115.803L136.8 322.492Z",
    fill: "#1C262B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M130.837 322.492H324.667V115.803L130.837 115.803L130.837 322.492Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.05 312.981H316.788V122.383L139.05 122.383L139.05 312.981Z",
    fill: "#37474F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M139.032 312.981H144.18L144.18 122.383H139.032L139.032 312.981Z",
    fill: "#1C262B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.631 259.443V264.59H317.238V259.443H143.631Z",
    fill: "#1C262B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M139.034 259.443H319.537V250.814L139.034 250.814V259.443Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M630.988 151.184C630.988 151.184 632.653 140.19 624.641 133.144C616.629 126.097 617.328 121.9 619.644 121.35C621.959 120.8 624.041 127.863 627.573 129.795C627.573 129.795 627.689 119.801 624.108 116.053C620.527 112.305 618.644 102.826 622.059 102.726C625.474 102.626 625.807 108.39 626.523 112.521C627.24 116.652 631.021 122.516 631.021 122.516C631.021 122.516 631.754 113.521 634.069 109.823C636.385 106.125 630.221 97.6625 632.603 93.9645C634.985 90.2664 639.267 97.296 638.85 105.242C638.434 113.188 633.22 121.633 634.452 129.912C634.452 129.912 636.785 124.098 638.867 123.565C640.949 123.032 643.081 119.201 644.48 117.768C645.88 116.336 647.662 121.283 644.48 125.864C641.299 130.445 633.22 142.705 634.486 152.6L630.988 151.184Z",
    fill: "#1C262A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M626.189 146.187L623.557 162.661C623.357 163.863 623.424 165.095 623.752 166.269C624.08 167.443 624.661 168.531 625.456 169.455C626.25 170.38 627.238 171.119 628.349 171.62C629.46 172.121 630.667 172.372 631.886 172.356H634.685C635.903 172.372 637.111 172.121 638.222 171.62C639.333 171.119 640.321 170.38 641.115 169.455C641.909 168.531 642.491 167.443 642.819 166.269C643.147 165.095 643.213 163.863 643.013 162.661L640.332 146.187H626.189Z",
    fill: "#303940"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M665.885 166.276H480.317V175.804H665.885V166.276Z",
    fill: "#1C262A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M497.041 131.128H488.862V166.276H497.041V131.128Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M536.571 131.128H528.392V166.276H536.571V131.128Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M581.455 130.235L573.395 131.624L579.365 166.261L587.425 164.872L581.455 130.235Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M507.169 135.759H498.99V166.276H507.169V135.759Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M525.959 135.759H517.78V166.276H525.959V135.759Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M573.401 135.759H565.222V166.276H573.401V135.759Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M547.306 134.679L539.322 136.454L545.943 166.244L553.927 164.47L547.306 134.679Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M514.232 129.379H510.15V166.276H514.232V129.379Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M562.856 129.379H558.774V166.276H562.856V129.379Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M480.334 246.983L665.901 246.983V237.454L480.334 237.454V246.983Z",
    fill: "#1C262A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M649.177 237.454H657.356V202.307H649.177V237.454Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M609.648 237.454H617.827V202.307H609.648V237.454Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M558.813 236.032L566.873 237.422L572.843 202.784L564.783 201.395L558.813 236.032Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M639.05 237.454H647.229V206.937H639.05V237.454Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M620.259 237.454H628.438V206.937H620.259V237.454Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M572.817 237.454H580.996V206.937H572.817V237.454Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M592.31 235.643L600.294 237.417L606.915 207.627L598.93 205.852L592.31 235.643Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M631.985 237.454H636.066V200.558H631.985V237.454Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M583.363 237.454H587.444V200.558H583.363V237.454Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M498.141 237.138H537.97V209.636H498.141V237.138Z",
    fill: "#303940"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M417.117 621.499C595.492 621.499 740.094 613.056 740.094 602.642C740.094 592.228 595.492 583.786 417.117 583.786C238.741 583.786 94.1396 592.228 94.1396 602.642C94.1396 613.056 238.741 621.499 417.117 621.499Z",
    fill: "#303940"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M554.495 560.981C554.495 560.981 546.166 542.991 555.661 525.234C565.156 507.476 567.821 503.312 561.824 499.681C555.828 496.049 553.046 513.956 553.046 513.956C550.062 505.901 549.752 497.098 552.163 488.853C556.344 476.01 558.976 455.104 553.262 452.856C547.549 450.607 552.179 478.942 547.215 488.603C544.689 481.826 543.059 474.747 542.368 467.548C541.685 457.237 542.751 440.762 538.237 436.548C533.723 432.333 530.841 435.232 535.272 458.003C537.935 471.597 539.407 485.397 539.67 499.247C539.67 499.247 529.891 469.397 523.312 468.531C516.732 467.664 516.748 477.326 522.379 485.705C528.009 494.084 538.853 509.109 540.619 516.838C540.619 516.838 529.875 494.383 520.213 501.263C510.552 508.143 528.625 521.719 536.688 526.616C544.75 531.514 550.347 562.247 550.347 562.247L554.495 560.981Z",
    fill: "url(#paint0_linear_2074_18550)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M554.495 560.981C554.495 560.981 546.166 542.991 555.661 525.234C565.156 507.476 567.821 503.312 561.824 499.681C555.828 496.049 553.046 513.956 553.046 513.956C550.062 505.901 549.752 497.098 552.163 488.853C556.344 476.01 558.976 455.104 553.262 452.856C547.549 450.607 552.179 478.942 547.215 488.603C544.689 481.826 543.059 474.747 542.368 467.548C541.685 457.237 542.751 440.762 538.237 436.548C533.723 432.333 530.841 435.232 535.272 458.003C537.935 471.597 539.407 485.397 539.67 499.247C539.67 499.247 529.891 469.397 523.312 468.531C516.732 467.664 516.748 477.326 522.379 485.705C528.009 494.084 538.853 509.109 540.619 516.838C540.619 516.838 529.875 494.383 520.213 501.263C510.552 508.143 528.625 521.719 536.688 526.616C544.75 531.514 550.347 562.247 550.347 562.247L554.495 560.981Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M547.982 568.36C547.982 568.36 556.011 550.237 546.316 532.646C536.621 515.056 533.89 510.891 539.853 507.177C545.817 503.462 548.782 521.236 548.782 521.236C551.671 513.143 551.875 504.334 549.365 496.116C545.034 483.356 542.152 462.484 547.849 460.152C553.546 457.82 549.248 486.221 554.312 495.799C556.763 488.985 558.309 481.878 558.91 474.661C559.476 464.349 558.21 447.892 562.674 443.611C567.138 439.33 570.054 442.195 565.889 465.016C563.385 478.646 562.081 492.469 561.991 506.327C561.991 506.327 571.42 476.343 577.983 475.377C584.546 474.411 584.646 484.072 579.115 492.534C573.585 500.997 562.941 516.188 561.242 523.934C561.242 523.934 571.719 501.313 581.464 508.059C591.209 514.806 573.302 528.632 565.306 533.662C557.31 538.693 552.08 569.493 552.08 569.493L547.982 568.36Z",
    fill: "url(#paint1_linear_2074_18550)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M585.029 555.451H518.664L524.045 602.942H579.665L585.029 555.451Z",
    fill: "#27343B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M715.376 83.187H364.63C362.349 83.187 360.499 85.0366 360.499 87.3181V398.851C360.499 401.133 362.349 402.983 364.63 402.983H715.376C717.657 402.983 719.507 401.133 719.507 398.851V87.3181C719.507 85.0366 717.657 83.187 715.376 83.187Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M701.8 77.2736H351.054C348.772 77.2736 346.923 79.1231 346.923 81.4047V392.938C346.923 395.22 348.772 397.069 351.054 397.069H701.8C704.081 397.069 705.931 395.22 705.931 392.938V81.4047C705.931 79.1231 704.081 77.2736 701.8 77.2736Z",
    fill: "url(#paint2_linear_2074_18550)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M346.923 105.842V392.955C346.837 393.94 347.136 394.92 347.757 395.69C348.378 396.46 349.273 396.96 350.254 397.086H702.499C703.498 396.984 704.418 396.495 705.06 395.722C705.701 394.949 706.014 393.956 705.93 392.955V105.842H346.923Z",
    fill: "#37474F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M701.667 122.683H351.171V376.33H701.667V122.683Z",
    fill: "#37474F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M694.204 97.0296C697.111 97.0296 699.468 94.1882 699.468 90.683C699.468 87.1779 697.111 84.3364 694.204 84.3364C691.297 84.3364 688.94 87.1779 688.94 90.683C688.94 94.1882 691.297 97.0296 694.204 97.0296Z",
    fill: "#37474F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M676.962 97.0296C679.869 97.0296 682.226 94.1882 682.226 90.683C682.226 87.1779 679.869 84.3364 676.962 84.3364C674.055 84.3364 671.698 87.1779 671.698 90.683C671.698 94.1882 674.055 97.0296 676.962 97.0296Z",
    fill: "#37474F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M664.969 90.683C664.969 94.1812 662.62 97.013 659.705 97.013C656.79 97.013 654.458 94.1812 654.458 90.683C654.458 87.1849 656.807 84.3364 659.705 84.3364C662.604 84.3364 664.969 87.1683 664.969 90.683Z",
    fill: "#37474F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M425.847 152.3V217.715L409.022 238.004H371.759V152.3H425.847Z",
    fill: "url(#paint3_linear_2074_18550)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M425.847 152.3V217.715L409.022 238.004H371.759V152.3H425.847Z",
    fill: "#37474F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M425.848 217.715L409.023 238.004V217.715H425.848Z",
    fill: "url(#paint4_linear_2074_18550)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M417.469 164.66H380.155V167.109H417.469V164.66Z",
    fill: "url(#paint5_linear_2074_18550)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M417.469 173.955H380.155V176.404H417.469V173.955Z",
    fill: "url(#paint6_linear_2074_18550)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M417.469 183.267H380.155V185.732H417.469V183.267Z",
    fill: "url(#paint7_linear_2074_18550)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M417.469 192.579H380.155V195.027H417.469V192.579Z",
    fill: "url(#paint8_linear_2074_18550)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M407.824 201.89H380.155V204.356H407.824V201.89Z",
    fill: "url(#paint9_linear_2074_18550)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M511.635 152.3V217.715L494.81 238.004H457.547V152.3H511.635Z",
    fill: "url(#paint10_linear_2074_18550)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M511.635 152.3V217.715L494.81 238.004H457.547V152.3H511.635Z",
    fill: "#37474F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M511.635 217.715L494.811 238.004V217.715H511.635Z",
    fill: "url(#paint11_linear_2074_18550)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M503.239 164.66H465.926V167.109H503.239V164.66Z",
    fill: "url(#paint12_linear_2074_18550)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M503.239 173.955H465.926V176.404H503.239V173.955Z",
    fill: "url(#paint13_linear_2074_18550)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M503.239 183.267H465.926V185.732H503.239V183.267Z",
    fill: "url(#paint14_linear_2074_18550)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M503.239 192.579H465.926V195.027H503.239V192.579Z",
    fill: "url(#paint15_linear_2074_18550)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M493.594 201.89H465.926V204.356H493.594V201.89Z",
    fill: "url(#paint16_linear_2074_18550)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M597.422 152.3V217.715L580.597 238.004H543.334V152.3H597.422Z",
    fill: "url(#paint17_linear_2074_18550)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M597.422 152.3V217.715L580.597 238.004H543.334V152.3H597.422Z",
    fill: "#37474F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M597.422 217.715L580.598 238.004V217.715H597.422Z",
    fill: "url(#paint18_linear_2074_18550)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M589.026 164.66H551.713V167.109H589.026V164.66Z",
    fill: "url(#paint19_linear_2074_18550)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M589.026 173.955H551.713V176.404H589.026V173.955Z",
    fill: "url(#paint20_linear_2074_18550)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M589.026 183.267H551.713V185.732H589.026V183.267Z",
    fill: "url(#paint21_linear_2074_18550)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M589.026 192.579H551.713V195.027H589.026V192.579Z",
    fill: "url(#paint22_linear_2074_18550)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M579.381 201.89H551.713V204.356H579.381V201.89Z",
    fill: "url(#paint23_linear_2074_18550)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M683.21 152.3V217.715L666.369 238.004H629.122V152.3H683.21Z",
    fill: "url(#paint24_linear_2074_18550)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M683.21 152.3V217.715L666.369 238.004H629.122V152.3H683.21Z",
    fill: "#37474F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M683.209 217.715L666.368 238.004V217.715H683.209Z",
    fill: "url(#paint25_linear_2074_18550)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M674.814 164.66H637.501V167.109H674.814V164.66Z",
    fill: "url(#paint26_linear_2074_18550)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M674.814 173.955H637.501V176.404H674.814V173.955Z",
    fill: "url(#paint27_linear_2074_18550)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M674.814 183.267H637.501V185.732H674.814V183.267Z",
    fill: "url(#paint28_linear_2074_18550)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M674.814 192.579H637.501V195.027H674.814V192.579Z",
    fill: "url(#paint29_linear_2074_18550)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M665.17 201.89H637.501V204.356H665.17V201.89Z",
    fill: "url(#paint30_linear_2074_18550)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M425.847 265.573V330.988L409.022 351.277H371.759V265.573H425.847Z",
    fill: "url(#paint31_linear_2074_18550)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M425.847 265.573V330.988L409.022 351.277H371.759V265.573H425.847Z",
    fill: "#37474F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M425.848 330.988L409.023 351.277V330.988H425.848Z",
    fill: "url(#paint32_linear_2074_18550)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M417.469 277.933H380.155V280.382H417.469V277.933Z",
    fill: "url(#paint33_linear_2074_18550)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M417.469 287.228H380.155V289.677H417.469V287.228Z",
    fill: "url(#paint34_linear_2074_18550)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M417.469 296.54H380.155V299.005H417.469V296.54Z",
    fill: "url(#paint35_linear_2074_18550)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M417.469 305.851H380.155V308.317H417.469V305.851Z",
    fill: "url(#paint36_linear_2074_18550)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M407.824 315.163H380.155V317.612H407.824V315.163Z",
    fill: "url(#paint37_linear_2074_18550)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M511.635 265.573V330.988L494.81 351.277H457.547V265.573H511.635Z",
    fill: "url(#paint38_linear_2074_18550)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M511.635 265.573V330.988L494.81 351.277H457.547V265.573H511.635Z",
    fill: "#37474F"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M511.635 330.988L494.811 351.277V330.988H511.635Z",
    fill: "url(#paint39_linear_2074_18550)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M503.239 277.933H465.926V280.382H503.239V277.933Z",
    fill: "url(#paint40_linear_2074_18550)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M503.239 287.228H465.926V289.677H503.239V287.228Z",
    fill: "url(#paint41_linear_2074_18550)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M503.239 296.54H465.926V299.005H503.239V296.54Z",
    fill: "url(#paint42_linear_2074_18550)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M503.239 305.851H465.926V308.317H503.239V305.851Z",
    fill: "url(#paint43_linear_2074_18550)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M493.594 315.163H465.926V317.612H493.594V315.163Z",
    fill: "url(#paint44_linear_2074_18550)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M597.422 265.573V330.988L580.597 351.277H543.334V265.573H597.422Z",
    fill: "url(#paint45_linear_2074_18550)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M597.422 265.573V330.988L580.597 351.277H543.334V265.573H597.422Z",
    fill: "#37474F"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M597.422 330.988L580.598 351.277V330.988H597.422Z",
    fill: "url(#paint46_linear_2074_18550)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M589.026 277.933H551.713V280.382H589.026V277.933Z",
    fill: "url(#paint47_linear_2074_18550)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M589.026 287.228H551.713V289.677H589.026V287.228Z",
    fill: "url(#paint48_linear_2074_18550)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M589.026 296.54H551.713V299.005H589.026V296.54Z",
    fill: "url(#paint49_linear_2074_18550)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M589.026 305.851H551.713V308.317H589.026V305.851Z",
    fill: "url(#paint50_linear_2074_18550)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M579.381 315.163H551.713V317.612H579.381V315.163Z",
    fill: "url(#paint51_linear_2074_18550)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M683.21 265.573V330.988L666.369 351.277H629.122V265.573H683.21Z",
    fill: "url(#paint52_linear_2074_18550)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M683.21 265.573V330.988L666.369 351.277H629.122V265.573H683.21Z",
    fill: "#37474F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M683.209 330.988L666.368 351.277V330.988H683.209Z",
    fill: "url(#paint53_linear_2074_18550)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M674.814 277.933H637.501V280.382H674.814V277.933Z",
    fill: "url(#paint54_linear_2074_18550)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M674.814 287.228H637.501V289.677H674.814V287.228Z",
    fill: "url(#paint55_linear_2074_18550)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M674.814 296.54H637.501V299.005H674.814V296.54Z",
    fill: "url(#paint56_linear_2074_18550)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M674.814 305.851H637.501V308.317H674.814V305.851Z",
    fill: "url(#paint57_linear_2074_18550)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M665.17 315.163H637.501V317.612H665.17V315.163Z",
    fill: "url(#paint58_linear_2074_18550)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M550.313 211.369H463.976C459.974 211.369 456.729 214.613 456.729 218.615V283.313C456.729 287.315 459.974 290.559 463.976 290.559H550.313C554.315 290.559 557.559 287.315 557.559 283.313V218.615C557.559 214.613 554.315 211.369 550.313 211.369Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.132 207.687H534.137V196.876C534.137 190.046 531.424 183.496 526.594 178.666C521.765 173.836 515.214 171.123 508.384 171.123C501.554 171.123 495.004 173.836 490.174 178.666C485.345 183.496 482.631 190.046 482.631 196.876V207.687H472.637V196.876C472.637 187.395 476.403 178.303 483.107 171.599C489.811 164.895 498.903 161.129 508.384 161.129C517.865 161.129 526.958 164.895 533.662 171.599C540.366 178.303 544.132 187.395 544.132 196.876V207.687Z",
    fill: "black"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M543.466 208.037H457.129C453.127 208.037 449.883 211.281 449.883 215.283V279.982C449.883 283.984 453.127 287.228 457.129 287.228H543.466C547.468 287.228 550.712 283.984 550.712 279.982V215.283C550.712 211.281 547.468 208.037 543.466 208.037Z",
    fill: "url(#paint59_linear_2074_18550)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M543.466 208.037H457.129C453.127 208.037 449.883 211.281 449.883 215.283V279.982C449.883 283.984 453.127 287.228 457.129 287.228H543.466C547.468 287.228 550.712 283.984 550.712 279.982V215.283C550.712 211.281 547.468 208.037 543.466 208.037Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M543.466 208.037H457.129C453.127 208.037 449.883 211.281 449.883 215.283V279.982C449.883 283.984 453.127 287.228 457.129 287.228H543.466C547.468 287.228 550.712 283.984 550.712 279.982V215.283C550.712 211.281 547.468 208.037 543.466 208.037Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M525.226 208.037H457.129C453.127 208.037 449.883 211.281 449.883 215.283V279.982C449.883 283.984 453.127 287.228 457.129 287.228H525.226C529.228 287.228 532.472 283.984 532.472 279.982V215.283C532.472 211.281 529.228 208.037 525.226 208.037Z",
    fill: "url(#paint60_linear_2074_18550)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M496.242 237.754C496.242 232.291 492.911 227.86 488.813 227.86C484.715 227.86 481.4 232.291 481.4 237.754C481.301 239.555 481.679 241.35 482.495 242.959C483.311 244.567 484.536 245.932 486.048 246.916L484.665 267.572H492.994L491.628 246.916C493.131 245.926 494.348 244.558 495.158 242.951C495.967 241.343 496.341 239.552 496.242 237.754Z",
    fill: "#263238"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M537.286 204.355H527.291V193.545C527.291 186.714 524.578 180.164 519.749 175.334C514.919 170.505 508.369 167.792 501.539 167.792C494.709 167.792 488.158 170.505 483.329 175.334C478.499 180.164 475.786 186.714 475.786 193.545V204.355H465.791V193.545C465.791 184.064 469.557 174.971 476.261 168.267C482.965 161.563 492.058 157.797 501.539 157.797C511.019 157.797 520.112 161.563 526.816 168.267C533.52 174.971 537.286 184.064 537.286 193.545V204.355Z",
    fill: "#263238"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M537.286 204.355H527.291V193.545C527.291 186.714 524.578 180.164 519.749 175.334C514.919 170.505 508.369 167.792 501.539 167.792C494.709 167.792 488.158 170.505 483.329 175.334C478.499 180.164 475.786 186.714 475.786 193.545V204.355H465.791V193.545C465.791 184.064 469.557 174.971 476.261 168.267C482.965 161.563 492.058 157.797 501.539 157.797C511.019 157.797 520.112 161.563 526.816 168.267C533.52 174.971 537.286 184.064 537.286 193.545V204.355Z",
    fill: "#263238"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M537.286 193.545V204.356H530.506V192.312C530.506 188.023 529.661 183.776 528.019 179.814C526.377 175.852 523.971 172.252 520.937 169.22C517.904 166.188 514.303 163.783 510.34 162.143C506.376 160.504 502.129 159.661 497.84 159.663C491.286 159.642 484.885 161.65 479.517 165.41C484.789 161.275 491.119 158.707 497.782 157.999C504.445 157.291 511.172 158.472 517.196 161.407C523.22 164.341 528.297 168.911 531.846 174.594C535.396 180.277 537.275 186.844 537.269 193.545H537.286Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M361.247 385.075H320.868V383.526H329.98C330.593 383.52 331.184 383.301 331.653 382.905C332.121 382.51 332.437 381.964 332.545 381.361L336.626 357.074L337.426 352.293H351.252L363.629 381.477C363.797 381.871 363.865 382.3 363.826 382.726C363.788 383.152 363.644 383.562 363.408 383.919C363.172 384.275 362.851 384.568 362.473 384.77C362.096 384.972 361.674 385.077 361.247 385.075Z",
    fill: "url(#paint61_linear_2074_18550)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M361.247 385.075H320.868V383.526H329.98C330.593 383.52 331.184 383.301 331.653 382.905C332.121 382.51 332.437 381.964 332.545 381.361L336.626 357.074L337.426 352.293H351.252L363.629 381.477C363.797 381.871 363.865 382.3 363.826 382.726C363.788 383.152 363.644 383.562 363.408 383.919C363.172 384.275 362.851 384.568 362.473 384.77C362.096 384.972 361.674 385.077 361.247 385.075Z",
    fill: "#37474F"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M361.297 383.526H329.98C330.593 383.52 331.185 383.301 331.653 382.906C332.122 382.51 332.437 381.964 332.546 381.361L336.627 357.074H351.119L362.147 382.244C362.208 382.384 362.233 382.537 362.22 382.689C362.206 382.842 362.155 382.988 362.071 383.116C361.986 383.244 361.871 383.348 361.736 383.42C361.601 383.491 361.45 383.528 361.297 383.526Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M382.952 361.238H302.178C301.995 361.246 301.812 361.211 301.644 361.136C301.476 361.061 301.328 360.948 301.212 360.806C301.095 360.663 301.014 360.496 300.973 360.316C300.933 360.137 300.935 359.951 300.979 359.772L312.473 299.071C312.557 298.681 312.764 298.328 313.064 298.064C313.364 297.8 313.741 297.639 314.139 297.606H394.895C395.079 297.597 395.262 297.631 395.429 297.706C395.597 297.782 395.744 297.895 395.859 298.038C395.974 298.181 396.054 298.349 396.092 298.529C396.13 298.708 396.126 298.894 396.078 299.071L384.618 359.756C384.537 360.149 384.331 360.506 384.031 360.773C383.73 361.04 383.352 361.203 382.952 361.238Z",
    fill: "url(#paint62_linear_2074_18550)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M382.952 361.238H302.178C301.995 361.246 301.812 361.211 301.644 361.136C301.476 361.061 301.328 360.948 301.212 360.806C301.095 360.663 301.014 360.496 300.973 360.316C300.933 360.137 300.935 359.951 300.979 359.772L312.473 299.071C312.557 298.681 312.764 298.328 313.064 298.064C313.364 297.8 313.741 297.639 314.139 297.606H394.895C395.079 297.597 395.262 297.631 395.429 297.706C395.597 297.782 395.744 297.895 395.859 298.038C395.974 298.181 396.054 298.349 396.092 298.529C396.13 298.708 396.126 298.894 396.078 299.071L384.618 359.756C384.537 360.149 384.331 360.506 384.031 360.773C383.73 361.04 383.352 361.203 382.952 361.238Z",
    fill: "#37474F"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M381.287 361.238H300.513C300.33 361.246 300.147 361.211 299.979 361.136C299.811 361.061 299.663 360.948 299.547 360.806C299.43 360.663 299.349 360.496 299.308 360.316C299.268 360.137 299.27 359.951 299.314 359.772L310.808 299.071C310.892 298.681 311.099 298.328 311.399 298.064C311.699 297.8 312.076 297.639 312.474 297.606H393.23C393.414 297.597 393.597 297.631 393.764 297.706C393.932 297.782 394.079 297.895 394.194 298.038C394.309 298.181 394.389 298.349 394.427 298.529C394.465 298.708 394.461 298.894 394.413 299.071L382.953 359.756C382.872 360.149 382.666 360.506 382.366 360.773C382.065 361.04 381.687 361.203 381.287 361.238Z",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M380.22 357.507H302.995L313.623 301.354H390.831L380.22 357.507Z",
    fill: "url(#paint63_linear_2074_18550)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M245.626 385.075V383.176L276.709 376.896H337.527C338.609 376.896 339.647 377.326 340.413 378.092C341.178 378.857 341.608 379.895 341.608 380.978C341.608 382.061 341.179 383.101 340.414 383.869C339.649 384.637 338.611 385.071 337.527 385.075H245.626Z",
    fill: "url(#paint64_linear_2074_18550)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M341.608 380.994C341.61 382.073 341.185 383.11 340.425 383.876C339.654 384.641 338.613 385.072 337.527 385.075H245.626V383.193L276.726 376.896H337.527C338.064 376.896 338.596 377.002 339.092 377.209C339.589 377.415 340.039 377.717 340.419 378.098C340.798 378.478 341.098 378.93 341.302 379.427C341.506 379.924 341.61 380.457 341.608 380.994Z",
    fill: "#37474F"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M341.608 380.994C341.61 382.073 341.185 383.11 340.425 383.876C339.654 384.641 338.613 385.072 337.527 385.075H300.597V383.193L331.697 376.896H337.527C338.064 376.896 338.596 377.002 339.093 377.209C339.589 377.415 340.039 377.717 340.419 378.098C340.798 378.478 341.098 378.93 341.302 379.427C341.506 379.924 341.61 380.457 341.608 380.994Z",
    fill: "#37474F"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M363.83 602.942H372.159L387.101 394.82H376.057L363.83 602.942Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M363.83 602.942H372.159L386.368 405.148L387.101 395.153H376.057L375.474 405.148L363.83 602.942Z",
    fill: "#37474F"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M375.473 404.648H386.367L387.1 395.153H376.056L375.473 404.648Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M302.779 602.942H311.091L312.457 394.82H301.413L302.779 602.942Z",
    fill: "#263238"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M301.413 395.153L301.63 428.735L302.762 602.942H311.091L312.224 428.735L312.441 395.153H301.413Z",
    fill: "#37474F"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M301.413 395.153L301.63 429.102H312.224L312.441 395.153H301.413Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M214.442 602.942H222.755L237.713 394.82H226.669L214.442 602.942Z",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M214.427 602.942H222.756L236.981 405.148L237.714 395.153H226.67L226.071 405.148L214.427 602.942Z",
    fill: "#37474F"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M226.07 404.648H236.981L237.714 395.153H226.67L226.07 404.648Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M459.011 602.942H467.324L455.097 394.82H444.069L459.011 602.942Z",
    fill: "#263238"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M444.069 395.153L444.802 405.148L459.011 602.942H467.324L455.696 405.148L455.097 395.153H444.069Z",
    fill: "#37474F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M455.097 395.153H444.069L444.802 404.648H455.696L455.097 395.153Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M460.245 400.017L221.522 400.017C221.05 400.017 220.582 399.924 220.146 399.743C219.709 399.563 219.312 399.298 218.978 398.964C218.644 398.629 218.379 398.233 218.198 397.796C218.017 397.36 217.924 396.892 217.924 396.419V389.59L463.843 389.59V396.419C463.843 396.892 463.75 397.36 463.569 397.796C463.388 398.233 463.123 398.629 462.789 398.964C462.455 399.298 462.058 399.563 461.622 399.743C461.185 399.924 460.717 400.017 460.245 400.017Z",
    fill: "url(#paint65_linear_2074_18550)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M460.245 400.017L221.522 400.017C221.05 400.017 220.582 399.924 220.146 399.743C219.709 399.563 219.312 399.298 218.978 398.964C218.644 398.629 218.379 398.233 218.198 397.796C218.017 397.36 217.924 396.892 217.924 396.419V389.59L463.843 389.59V396.419C463.843 396.892 463.75 397.36 463.569 397.796C463.388 398.233 463.123 398.629 462.789 398.964C462.455 399.298 462.058 399.563 461.622 399.743C461.185 399.924 460.717 400.017 460.245 400.017Z",
    fill: "#37474F"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M217.908 394.804L463.843 394.804V389.59L217.908 389.59V394.804Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M212.76 390.956H469.006C469.784 390.956 470.529 390.647 471.079 390.097C471.629 389.547 471.938 388.801 471.938 388.024C471.938 387.246 471.629 386.501 471.079 385.951C470.529 385.401 469.784 385.092 469.006 385.092H212.76C211.982 385.092 211.237 385.401 210.687 385.951C210.137 386.501 209.828 387.246 209.828 388.024C209.828 388.801 210.137 389.547 210.687 390.097C211.237 390.647 211.982 390.956 212.76 390.956Z",
    fill: "url(#paint66_linear_2074_18550)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.76 390.956H469.006C469.784 390.956 470.529 390.647 471.079 390.097C471.629 389.547 471.938 388.801 471.938 388.024C471.938 387.246 471.629 386.501 471.079 385.951C470.529 385.401 469.784 385.092 469.006 385.092H212.76C211.982 385.092 211.237 385.401 210.687 385.951C210.137 386.501 209.828 387.246 209.828 388.024C209.828 388.801 210.137 389.547 210.687 390.097C211.237 390.647 211.982 390.956 212.76 390.956Z",
    fill: "#37474F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M317.904 332.82C317.538 332.817 317.177 332.733 316.848 332.575C316.518 332.417 316.226 332.189 315.994 331.906C315.763 331.623 315.595 331.293 315.505 330.939C315.415 330.584 315.403 330.214 315.472 329.855L316.504 324.541C316.65 323.816 317.041 323.164 317.611 322.693C318.182 322.223 318.897 321.964 319.636 321.959H362.946C363.314 321.958 363.677 322.04 364.009 322.199C364.34 322.357 364.632 322.589 364.862 322.875C365.099 323.155 365.268 323.485 365.358 323.84C365.447 324.195 365.454 324.566 365.378 324.924L364.346 330.238C364.206 330.963 363.82 331.617 363.251 332.088C362.683 332.559 361.969 332.818 361.231 332.82H317.904Z",
    fill: "#37474F"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M361.231 331.987H317.921C317.674 331.991 317.43 331.94 317.205 331.839C316.981 331.737 316.782 331.587 316.623 331.399C316.463 331.211 316.348 330.989 316.284 330.751C316.22 330.513 316.21 330.264 316.255 330.022L317.304 324.691C317.405 324.156 317.691 323.673 318.11 323.326C318.53 322.979 319.058 322.79 319.603 322.792H362.913C363.16 322.788 363.404 322.839 363.628 322.941C363.853 323.042 364.052 323.193 364.211 323.381C364.371 323.569 364.486 323.79 364.55 324.028C364.613 324.266 364.623 324.515 364.579 324.758L363.546 330.088C363.441 330.625 363.153 331.108 362.73 331.455C362.308 331.801 361.777 331.99 361.231 331.987Z",
    fill: "#37474F"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M325.246 328.629C326.095 327.415 326.001 325.884 325.036 325.209C324.071 324.534 322.601 324.971 321.752 326.185C320.903 327.398 320.997 328.929 321.962 329.604C322.927 330.279 324.397 329.842 325.246 328.629Z",
    fill: "#263238"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M332.546 327.39C332.427 328.055 332.091 328.663 331.591 329.118C331.091 329.573 330.455 329.849 329.781 329.905C329.482 329.896 329.19 329.817 328.927 329.676C328.664 329.535 328.437 329.335 328.264 329.091C328.091 328.847 327.977 328.567 327.931 328.271C327.885 327.976 327.908 327.674 327.999 327.39C328.12 326.725 328.457 326.119 328.956 325.665C329.456 325.21 330.091 324.933 330.764 324.874C331.064 324.88 331.358 324.956 331.623 325.097C331.888 325.237 332.116 325.437 332.29 325.682C332.463 325.927 332.577 326.209 332.621 326.505C332.666 326.802 332.64 327.105 332.546 327.39Z",
    fill: "#263238"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M339.325 327.39C339.204 328.054 338.867 328.66 338.368 329.114C337.868 329.569 337.233 329.847 336.56 329.905C336.26 329.898 335.966 329.822 335.7 329.682C335.435 329.541 335.206 329.341 335.032 329.097C334.857 328.853 334.742 328.572 334.695 328.275C334.648 327.979 334.67 327.676 334.761 327.39C334.886 326.724 335.226 326.118 335.728 325.663C336.231 325.209 336.868 324.932 337.543 324.874C337.842 324.884 338.134 324.962 338.397 325.103C338.66 325.244 338.887 325.445 339.06 325.689C339.233 325.932 339.347 326.213 339.393 326.508C339.439 326.803 339.416 327.105 339.325 327.39Z",
    fill: "#263238"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M345.573 328.616C346.422 327.403 346.327 325.872 345.362 325.197C344.398 324.522 342.927 324.959 342.078 326.172C341.229 327.386 341.323 328.917 342.288 329.592C343.253 330.267 344.724 329.83 345.573 328.616Z",
    fill: "#263238"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M352.868 327.39C352.743 328.055 352.404 328.662 351.901 329.116C351.399 329.57 350.761 329.847 350.087 329.905C349.788 329.896 349.496 329.817 349.232 329.676C348.969 329.535 348.742 329.335 348.57 329.091C348.397 328.847 348.283 328.567 348.237 328.271C348.191 327.976 348.214 327.674 348.304 327.39C348.428 326.727 348.766 326.122 349.265 325.668C349.764 325.214 350.397 324.935 351.069 324.874C351.369 324.881 351.664 324.958 351.929 325.098C352.194 325.238 352.423 325.438 352.598 325.682C352.773 325.926 352.888 326.208 352.935 326.504C352.982 326.8 352.959 327.104 352.868 327.39Z",
    fill: "#263238"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M359.105 328.643C359.954 327.429 359.86 325.898 358.895 325.223C357.93 324.548 356.459 324.985 355.61 326.199C354.761 327.413 354.856 328.944 355.82 329.619C356.785 330.294 358.256 329.857 359.105 328.643Z",
    fill: "#263238"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M367.278 332.82C366.998 332.823 366.721 332.764 366.467 332.646C366.213 332.527 365.989 332.354 365.812 332.137C365.622 331.909 365.489 331.639 365.422 331.35C365.356 331.06 365.358 330.76 365.429 330.471L366.745 323.808C366.861 323.262 367.157 322.771 367.586 322.415C368.015 322.058 368.552 321.857 369.11 321.843H375.773C376.053 321.839 376.33 321.899 376.584 322.017C376.838 322.135 377.062 322.309 377.239 322.526C377.429 322.754 377.562 323.024 377.629 323.313C377.695 323.602 377.693 323.903 377.622 324.191L376.306 330.854C376.19 331.4 375.894 331.891 375.465 332.248C375.036 332.604 374.499 332.806 373.941 332.82H367.278Z",
    fill: "#37474F"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M367.278 331.987H373.941C374.298 331.969 374.64 331.836 374.916 331.608C375.192 331.38 375.388 331.069 375.473 330.721L376.789 324.058C376.831 323.902 376.835 323.739 376.803 323.581C376.77 323.423 376.7 323.275 376.6 323.148C376.5 323.022 376.371 322.921 376.224 322.853C376.078 322.786 375.918 322.753 375.756 322.759H369.093C368.728 322.775 368.379 322.912 368.099 323.146C367.819 323.381 367.624 323.701 367.544 324.058L366.228 330.721C366.192 330.876 366.192 331.037 366.229 331.192C366.265 331.347 366.337 331.492 366.439 331.614C366.54 331.737 366.669 331.834 366.815 331.899C366.96 331.964 367.118 331.994 367.278 331.987Z",
    fill: "#263238"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M370.658 330.305C370.608 330.307 370.558 330.297 370.511 330.277C370.465 330.257 370.424 330.226 370.392 330.188C370.332 330.092 370.311 329.977 370.332 329.865C370.354 329.754 370.417 329.655 370.508 329.588L373.157 327.39L371.391 325.191C371.327 325.096 371.304 324.979 371.326 324.867C371.347 324.754 371.413 324.655 371.508 324.591C371.587 324.519 371.691 324.478 371.799 324.478C371.907 324.478 372.011 324.519 372.091 324.591L374.09 327.09C374.153 327.185 374.177 327.301 374.155 327.414C374.133 327.526 374.068 327.625 373.973 327.689L370.991 330.188C370.897 330.265 370.779 330.306 370.658 330.305Z",
    fill: "url(#paint67_linear_2074_18550)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M373.657 327.806H369.159C369.107 327.808 369.056 327.797 369.009 327.776C368.962 327.754 368.921 327.722 368.888 327.681C368.856 327.641 368.834 327.593 368.823 327.543C368.812 327.492 368.813 327.44 368.826 327.39C368.852 327.275 368.915 327.172 369.005 327.096C369.095 327.021 369.208 326.978 369.326 326.973H373.807C373.858 326.972 373.91 326.982 373.957 327.004C374.004 327.025 374.045 327.058 374.078 327.098C374.11 327.138 374.132 327.186 374.143 327.236C374.154 327.287 374.153 327.34 374.14 327.39C374.115 327.502 374.055 327.603 373.967 327.678C373.88 327.753 373.771 327.798 373.657 327.806Z",
    fill: "url(#paint68_linear_2074_18550)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M241.745 224.245L245.626 240.936L249.508 224.245H241.745Z",
    fill: "url(#paint69_linear_2074_18550)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M227.669 226.111H263.583C267.374 226.111 270.446 223.038 270.446 219.248V183.333C270.446 179.543 267.374 176.47 263.583 176.47H227.669C223.879 176.47 220.806 179.543 220.806 183.333V219.248C220.806 223.038 223.879 226.111 227.669 226.111Z",
    fill: "url(#paint70_linear_2074_18550)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M245.194 216.166C240.969 213.647 237.442 210.112 234.934 205.881C232.426 201.651 231.017 196.86 230.835 191.945V191.412L245.61 185.116L260.369 191.412V191.945C260.198 196.86 258.795 201.654 256.289 205.886C253.783 210.118 250.254 213.652 246.027 216.166L245.594 216.432L245.194 216.166Z",
    fill: "#37474F"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M245.627 186.032L259.569 191.962C259.417 196.738 258.059 201.398 255.621 205.507C253.183 209.617 249.745 213.043 245.627 215.466V186.032Z",
    fill: "#37474F"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M245.626 186.032L231.667 191.962C231.821 196.74 233.182 201.4 235.623 205.51C238.063 209.62 241.505 213.045 245.626 215.466V186.032Z",
    fill: "#37474F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2074_18550",
    x1: 529.49,
    y1: 418.157,
    x2: 600.209,
    y2: 440.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2074_18550",
    x1: 548.762,
    y1: 425.148,
    x2: 619.511,
    y2: 447.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2074_18550",
    x1: 437.837,
    y1: 35.1753,
    x2: 744.366,
    y2: 328.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2074_18550",
    x1: 385.456,
    y1: 141.018,
    x2: 454.112,
    y2: 177.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2074_18550",
    x1: 413.284,
    y1: 215.044,
    x2: 431.641,
    y2: 228.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2074_18550",
    x1: 389.604,
    y1: 164.338,
    x2: 389.964,
    y2: 169.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2074_18550",
    x1: 389.604,
    y1: 173.633,
    x2: 389.964,
    y2: 178.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2074_18550",
    x1: 389.604,
    y1: 182.942,
    x2: 389.968,
    y2: 187.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2074_18550",
    x1: 389.604,
    y1: 192.256,
    x2: 389.964,
    y2: 196.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2074_18550",
    x1: 387.162,
    y1: 201.566,
    x2: 387.651,
    y2: 206.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2074_18550",
    x1: 471.244,
    y1: 141.018,
    x2: 539.9,
    y2: 177.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2074_18550",
    x1: 499.071,
    y1: 215.044,
    x2: 517.428,
    y2: 228.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2074_18550",
    x1: 475.375,
    y1: 164.338,
    x2: 475.734,
    y2: 169.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2074_18550",
    x1: 475.375,
    y1: 173.633,
    x2: 475.734,
    y2: 178.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2074_18550",
    x1: 475.375,
    y1: 182.942,
    x2: 475.739,
    y2: 187.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2074_18550",
    x1: 475.375,
    y1: 192.256,
    x2: 475.734,
    y2: 196.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2074_18550",
    x1: 472.932,
    y1: 201.566,
    x2: 473.421,
    y2: 206.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2074_18550",
    x1: 557.031,
    y1: 141.018,
    x2: 625.687,
    y2: 177.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2074_18550",
    x1: 584.858,
    y1: 215.044,
    x2: 603.215,
    y2: 228.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2074_18550",
    x1: 561.162,
    y1: 164.338,
    x2: 561.521,
    y2: 169.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2074_18550",
    x1: 561.162,
    y1: 173.633,
    x2: 561.521,
    y2: 178.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2074_18550",
    x1: 561.162,
    y1: 182.942,
    x2: 561.526,
    y2: 187.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2074_18550",
    x1: 561.162,
    y1: 192.256,
    x2: 561.521,
    y2: 196.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2074_18550",
    x1: 558.72,
    y1: 201.566,
    x2: 559.208,
    y2: 206.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2074_18550",
    x1: 642.819,
    y1: 141.018,
    x2: 711.475,
    y2: 177.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2074_18550",
    x1: 670.633,
    y1: 215.044,
    x2: 688.996,
    y2: 228.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2074_18550",
    x1: 646.95,
    y1: 164.338,
    x2: 647.309,
    y2: 169.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2074_18550",
    x1: 646.95,
    y1: 173.633,
    x2: 647.309,
    y2: 178.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2074_18550",
    x1: 646.95,
    y1: 182.942,
    x2: 647.314,
    y2: 187.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2074_18550",
    x1: 646.95,
    y1: 192.256,
    x2: 647.309,
    y2: 196.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2074_18550",
    x1: 644.508,
    y1: 201.566,
    x2: 644.996,
    y2: 206.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2074_18550",
    x1: 385.456,
    y1: 254.291,
    x2: 454.112,
    y2: 291.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2074_18550",
    x1: 413.284,
    y1: 328.317,
    x2: 431.641,
    y2: 341.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2074_18550",
    x1: 389.604,
    y1: 277.611,
    x2: 389.964,
    y2: 282.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2074_18550",
    x1: 389.604,
    y1: 286.906,
    x2: 389.964,
    y2: 291.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2074_18550",
    x1: 389.604,
    y1: 296.215,
    x2: 389.968,
    y2: 300.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2074_18550",
    x1: 389.604,
    y1: 305.527,
    x2: 389.968,
    y2: 310.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2074_18550",
    x1: 387.162,
    y1: 314.841,
    x2: 387.644,
    y2: 319.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2074_18550",
    x1: 471.244,
    y1: 254.291,
    x2: 539.9,
    y2: 291.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2074_18550",
    x1: 499.071,
    y1: 328.317,
    x2: 517.428,
    y2: 341.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2074_18550",
    x1: 475.375,
    y1: 277.611,
    x2: 475.734,
    y2: 282.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2074_18550",
    x1: 475.375,
    y1: 286.906,
    x2: 475.734,
    y2: 291.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2074_18550",
    x1: 475.375,
    y1: 296.215,
    x2: 475.739,
    y2: 300.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2074_18550",
    x1: 475.375,
    y1: 305.527,
    x2: 475.739,
    y2: 310.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2074_18550",
    x1: 472.932,
    y1: 314.841,
    x2: 473.415,
    y2: 319.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2074_18550",
    x1: 557.031,
    y1: 254.291,
    x2: 625.687,
    y2: 291.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2074_18550",
    x1: 584.858,
    y1: 328.317,
    x2: 603.215,
    y2: 341.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2074_18550",
    x1: 561.162,
    y1: 277.611,
    x2: 561.521,
    y2: 282.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2074_18550",
    x1: 561.162,
    y1: 286.906,
    x2: 561.521,
    y2: 291.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2074_18550",
    x1: 561.162,
    y1: 296.215,
    x2: 561.526,
    y2: 300.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2074_18550",
    x1: 561.162,
    y1: 305.527,
    x2: 561.526,
    y2: 310.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2074_18550",
    x1: 558.72,
    y1: 314.841,
    x2: 559.202,
    y2: 319.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2074_18550",
    x1: 642.819,
    y1: 254.291,
    x2: 711.475,
    y2: 291.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2074_18550",
    x1: 670.633,
    y1: 328.317,
    x2: 688.996,
    y2: 341.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2074_18550",
    x1: 646.95,
    y1: 277.611,
    x2: 647.309,
    y2: 282.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2074_18550",
    x1: 646.95,
    y1: 286.906,
    x2: 647.309,
    y2: 291.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2074_18550",
    x1: 646.95,
    y1: 296.215,
    x2: 647.314,
    y2: 300.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2074_18550",
    x1: 646.95,
    y1: 305.527,
    x2: 647.314,
    y2: 310.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2074_18550",
    x1: 644.508,
    y1: 314.841,
    x2: 644.99,
    y2: 319.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2074_18550",
    x1: 475.416,
    y1: 197.612,
    x2: 551.13,
    y2: 279.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2074_18550",
    x1: 470.797,
    y1: 197.612,
    x2: 546.261,
    y2: 264.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2074_18550",
    x1: 331.749,
    y1: 347.977,
    x2: 363.004,
    y2: 382.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2074_18550",
    x1: 325.046,
    y1: 289.227,
    x2: 384.323,
    y2: 364.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2074_18550",
    x1: 325.238,
    y1: 293.961,
    x2: 376.939,
    y2: 362.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2074_18550",
    x1: 269.932,
    y1: 375.82,
    x2: 271.484,
    y2: 391.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2074_18550",
    x1: 401.567,
    y1: 401.39,
    x2: 400.576,
    y2: 381.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2074_18550",
    x1: 276.204,
    y1: 384.32,
    x2: 276.499,
    y2: 395.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2074_18550",
    x1: 371.296,
    y1: 323.711,
    x2: 376.073,
    y2: 326.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2074_18550",
    x1: 370.166,
    y1: 326.863,
    x2: 370.45,
    y2: 328.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2074_18550",
    x1: 243.711,
    y1: 222.048,
    x2: 254.693,
    y2: 226.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2074_18550",
    x1: 257.876,
    y1: 232.645,
    x2: 210.843,
    y2: 192.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage5);
export default __webpack_public_path__ + "static/media/Image 5.fa93e54c30a9f3722ff9a6487c9992cb.svg";
export { ForwardRef as ReactComponent };